export default "__VITE_ASSET__W9rWAi6s__"